import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const ProtectedDashboard = ({ isLogged, path, component: Component }) => (
	<Route
		path={path}
		render={(props) =>
			isLogged ? <Component {...props} /> : <Redirect to="/logowanie" />
		}
	/>
);

const mapStateToProps = ({ auth }) => {
	return {
		isLogged: auth.isLogged
	};
};

export default connect(mapStateToProps)(ProtectedDashboard);
